import { render, staticRenderFns } from "./UpButton.vue?vue&type=template&id=25a426d2&scoped=true&"
import script from "./UpButton.vue?vue&type=script&lang=js&"
export * from "./UpButton.vue?vue&type=script&lang=js&"
import style0 from "./UpButton.vue?vue&type=style&index=0&id=25a426d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a426d2",
  null
  
)

export default component.exports